module.exports = __webpack_public_path__ + "img/invalid.b2394781.png";